import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13px",
  height: "13px",
  viewBox: "0 0 13 13",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "bifang"),
  /*#__PURE__*/_createElementVNode("g", {
    id: "直播",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "切片",
      transform: "translate(-78.000000, -64.000000)",
      fill: "#FFFFFF",
      "fill-rule": "nonzero"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M79.7680939,64 L89.2245881,64 C90.2023653,64 91,64.6964299 91,65.5502541 L91,73.654849 C91,74.5086732 90.202364,75.2051031 89.2245881,75.2051031 L87.118136,75.2051031 L87.118136,75.2051031 C86.7575667,75.2032455 86.4034784,75.3009263 86.0948592,75.4873892 L83.8231282,76.8862894 C83.5074161,77.0831473 83.0709918,77.0176824 82.8448863,76.7418963 L82.8448863,76.7418963 C82.7637556,76.6413205 82.7187883,76.5163914 82.7172094,76.3871807 C82.7172094,75.7302143 82.1076071,75.2051056 81.3628974,75.2051056 L79.7755142,75.2051056 C78.797737,75.2051056 78.0000508,74.5086757 78.0000508,73.6548515 L78.0000508,65.5502566 C77.9926738,64.695969 78.7898457,64 79.7680875,64 L79.7680939,64 Z M86.9194306,69.1563673 L82.8504646,67.1218618 L82.8504646,67.1218618 C82.6210914,67.0072427 82.3422323,67.1002707 82.2276149,67.3296453 C82.1954505,67.3940134 82.178649,67.4649764 82.178649,67.5369337 L82.178649,71.6059445 L82.178649,71.6059233 C82.1787742,71.8623413 82.3867412,72.0701083 82.6431577,72.0699839 C82.715114,72.0699839 82.7860778,72.0531888 82.8504463,72.0210269 L86.9194123,69.9865215 L86.9194123,69.9865215 C87.1486484,69.8716288 87.2413424,69.592656 87.1264508,69.3634174 C87.0815753,69.2738791 87.0089496,69.2012521 86.9194123,69.1563766 L86.9194306,69.1563673 Z",
        id: "bifang"
      })
    ])
  ])
], -1 /* HOISTED */)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("?xml version=\"1.0\" encoding=\"UTF-8\"?"),
    _hoisted_1
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
export default render